import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

const oidcConfig = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid email profile roles offline_access',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

export const userManager = new UserManager(oidcConfig)

export const signinRedirect = () => userManager.signinRedirect()

export const signinCallback = () => userManager.signinRedirectCallback()

export const signoutRedirect = () => userManager.signoutRedirect()

export const getOidcUser = () => userManager.getUser()

export const silentRenew = () => userManager.signinSilent()
